import { useContext } from 'react';
import { middlewarePostOfUserWall } from '../../../../apis/tms/post.api';
import { FEED_LIST_BUSINESS_USER_WALL } from '../../../../constant/QueryKeyName';
import { GROUP_POST_PAGE_SIZE } from '../../../../constant/numericParams';
import useGetTMSUserIdByEmail from '../../../../hooks/useGetTMSUserIdByEmail';
import { TPostInfinityQuery } from '../../../../interfaces/post.interface';
import {
  IUserProfileData,
  RoleViewEnum,
} from '../../../../interfaces/profile.interface';
import { CreatePostButtonDesktop } from '../../../buttons/CreatePostButton';
import BusinessGroupProfileGallery from '../../../gallery/BusinessGroupProfileGallery';
import CreatePostInput from '../../../input/PostInput';
import EmptyScreen from '../../EmptyScreen';
import PostFeedWithInfinityQuery from '../../feed/post';
import { BusinessProfileModeContext } from './BusinessProfileModeProvider';

export default function BusinessHomeWallTab() {
  const { initData, data } = useContext(BusinessProfileModeContext);
  const isOwnerProfile = initData?.viewPermission === RoleViewEnum.Owner;
  const email = (data as IUserProfileData)?.profiles?.qbankData?.email;

  const {
    queryReturn: { data: tmsUserID },
  } = useGetTMSUserIdByEmail(email);
  return (
    <div className="flex w-full flex-col-reverse items-center gap-2 lg:flex-row lg:items-start lg:justify-center lg:gap-8">
      <div className="flex w-full max-w-[524px] flex-1 flex-col items-center justify-center md:w-full lg:w-auto">
        <div className="mx-4 mb-2 mt-6 flex w-full max-w-[100vw] flex-1 justify-center p-[0px_16px] sm:max-w-[524px]">
          {isOwnerProfile && <CreatePostInput />}
        </div>
        <PostFeedWithInfinityQuery
          queryFn={middlewarePostOfUserWall}
          queryKey={[
            FEED_LIST_BUSINESS_USER_WALL,
            tmsUserID as string,
            GROUP_POST_PAGE_SIZE,
          ]}
          opt={{
            enabled: !!tmsUserID,
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            keepPreviousData: true,
            cacheTime: 0,
            getNextPageParam: (
              _lastPage: TPostInfinityQuery,
              _allPages: TPostInfinityQuery[]
            ) => {
              return _lastPage?.hasNextPage
                ? _lastPage?.currentPage + 1
                : undefined;
            },
          }}
          emptyScreen={
            <EmptyScreen
              description={`${
                isOwnerProfile ? 'Bạn' : 'Người dùng này'
              } chưa tạo bài viết nào`}
              addNew={isOwnerProfile ? <CreatePostButtonDesktop /> : undefined}
            />
          }
        />
      </div>
      <div>
        <BusinessGroupProfileGallery />
      </div>
    </div>
  );
}
